"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Label.css");
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
function Label(_a) {
    var id = _a.id, _b = _a.appearance, appearance = _b === void 0 ? "default" : _b, Icon = _a.icon, label = _a.label, onClick = _a.onClick, colorTag = _a.colorTag;
    if (Icon && colorTag) {
        throw new Error("You can not use parameters 'icon' and 'colorTag' simultaneously");
    }
    if (appearance !== "default" && colorTag) {
        throw new Error("You can not use parameters 'appearance' and 'colorTag' simultaneously");
    }
    var handleClick = function (event) {
        event.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick(id);
    };
    var className = (0, classnames_1.default)("nimbus--label", "nimbus--label--".concat(appearance));
    var tagStyle = {
        backgroundColor: colorTag,
    };
    var renderLabel = label && React.createElement(__1.Text, { size: "caption" }, label);
    return onClick ? (React.createElement("button", { type: "button", id: id, className: className, onClick: handleClick },
        Icon && React.createElement(Icon, null),
        colorTag && (React.createElement("span", { className: "nimbus--label__color-tag", style: tagStyle })),
        renderLabel)) : (React.createElement("span", { id: id, className: className, role: "status" },
        Icon && React.createElement(Icon, null),
        colorTag && (React.createElement("span", { className: "nimbus--label__color-tag", style: tagStyle })),
        renderLabel));
}
var Skeleton = function () { return React.createElement("span", { className: "nimbus--label-skeleton" }); };
Label.Skeleton = Skeleton;
exports.default = Label;
//# sourceMappingURL=index.js.map